﻿import * as Repositories from '../../repositories/repositories'
import * as Model from '../../models/models';
import {SearchViewModel} from './search.viewmodel';
import {SearchResultModel} from './search.viewmodel';
import * as _ from 'lodash';
import { Constants } from '../../models/models';


export class SearchGateway {

    static $inject = ['$q', '$log', 'submissionRepository', 'policyholderuserRepository', 'userRepository', 'addressRepository', 'codeRepository'];

    constructor(private $q: ng.IQService,
        private $log: ng.ILogService,
        private submissionRepository: Repositories.SubmissionRepository,
        private policyholderuserRepository: Repositories.PolicyholderUserRepository,
        private userRepository: Repositories.UserRepository,
        private addressRepository: Repositories.AddressRepository,
        private codeRepository: Repositories.CodeRepository
    ) { }

    public loadSearchViewModel = (searchCriteriaModel: Model.ISubmissionSearchCriteria): ng.IPromise<SearchViewModel> => {

        const searchViewModel = new SearchViewModel();
        searchViewModel.searchResults = new Array<SearchResultModel>();

        searchCriteriaModel.excludeSubmissionStatusCIds = [Constants.SubmissionStatus.Draft];

        return this.getSubmissions(searchCriteriaModel)
            .then((submissions: Array<Model.ISubmission>) => {
                if (submissions.length === 0) throw Error("No results match search criteria");
                searchViewModel.submissions = submissions;
                return this.getPolicyHolderUsers(submissions);
            })
            .then((policyHolderUsers: Array<Model.IPolicyholderUser>) => {
                searchViewModel.policyholderusers = policyHolderUsers;
                return this.getUsers(policyHolderUsers);
            })
            .then((users: Array<Model.IUserProfile>) => {
                searchViewModel.users = users;
                return this.getControllingTaxAddresses(searchViewModel);
            })
            .then((searchViewModel: SearchViewModel) => {
                return this.getSubmissionStatusCodes(searchViewModel);
            })
            .then((searchViewModel: SearchViewModel) => {
                this.createSearchResults(searchViewModel);
                return searchViewModel;
            })
            .catch((err) => {
                console.log(err);
                return searchViewModel;
            });
    }

   
    private getSubmissions = (submissionSearch: Model.ISubmissionSearchCriteria): ng.IPromise<Array<Model.ISubmission>> => {
        return this.submissionRepository.submissionSearch(submissionSearch)
            .then((submissions: Array<Model.ISubmission>) => {
                return submissions;
            });
    }

    private getPolicyHolderUsers = (submissions: Array<Model.ISubmission>): ng.IPromise<Array<Model.IPolicyholderUser>> => {

        const submissionIds: Array<string> = <string[]>(_.map(submissions, 'id'));

        const policyHolderUserSearchCriteria = new Model.PolicyHolderUserSearchCriteria();
        policyHolderUserSearchCriteria.submissionIds = submissionIds;
        policyHolderUserSearchCriteria.policyHolderUserRelationshipTypeCodeId = Model.PolicyholderUserRelationshipType.primaryContact;

        return this.policyholderuserRepository.policyholderUserSearch(policyHolderUserSearchCriteria)
            .then((policyHolderUsers: Array<Model.IPolicyholderUser>) => {
                return policyHolderUsers;
            });

    }

    private getUsers = (policyHolderUsers: Array<Model.IPolicyholderUser>): ng.IPromise<Array<Model.IUserProfile>> => {

        const userIds: Array<string> = <string[]>(_.map(policyHolderUsers, 'userId'));

        return this.userRepository.getByIds(userIds)
            .then((users: Array<Model.IUserProfile>) => {
                return users;
            });

    }

    private getControllingTaxAddresses = (searchViewModel: SearchViewModel): ng.IPromise<SearchViewModel> => {

        const controllingTaxAddressIds: Array<string> = <string[]>(_.map(searchViewModel.submissions, 'controllingTaxAddressId'));

        return this.addressRepository.getAddressesByIds(controllingTaxAddressIds)
            .then((addresses: Array<Model.IAddress>) => {
                searchViewModel.controllingTaxAddresses = addresses;
                return searchViewModel;
            });

    };

    private getSubmissionStatusCodes = (searchViewModel: SearchViewModel): ng.IPromise<SearchViewModel> => {
        return this.codeRepository.getCodesByCodeTypeId("109")
            .then((codes: Model.ICode[]) => {
                searchViewModel.submissionStatusCodes = codes;
                return searchViewModel;
            });
    }

    private getStatusDescriptionById = (searchViewModel: SearchViewModel, statusCId: string): string => {
        var code = _.find(searchViewModel.submissionStatusCodes, (code: Model.ICode) => { return code.id === statusCId; });
        return code.codeDescription || "";
    } 


    private createSearchResults = (searchViewModel: SearchViewModel): SearchViewModel => {

        let searchResults = new Array<SearchResultModel>();

        //map submission data to search results
        _.forEach(searchViewModel.submissions, (submission: Model.ISubmission) => {
            let searchResult = new SearchResultModel();
            searchResult.submissionId = submission.id;
            searchResult.policyholderId = submission.policyholderId;
            searchResult.policyEffectiveDate = submission.policyEffectiveDate;
            searchResult.policyExpirationDate = submission.policyExpirationDate;
            searchResult.controllingTaxAddressId = submission.controllingTaxAddressId;
            searchResult.legalBusinessName = submission.legalBusinessName;
            searchResult.submissionStatusDescription = this.getStatusDescriptionById(searchViewModel, submission.statusCId);
            searchResult.underwritingOverride = submission.underwritingOverride;
            searchResults.push(searchResult);
        });

        //map userId to search results to join user
        _.forEach(searchViewModel.policyholderusers, (policyholderUser: Model.IPolicyholderUser) => {

            _.forEach(searchResults, (searchResultModel: SearchResultModel) => {
                if (searchResultModel.policyholderId === policyholderUser.policyholderId) {
                    searchResultModel.userId = policyholderUser.userId;
                }
            });
        });

         //map user data to search results 
        _.forEach(searchViewModel.users, (user: Model.IUserProfile) => {

            _.forEach(searchResults, (searchResultModel: SearchResultModel) => {
                if (searchResultModel.userId === user.id) {
                    searchResultModel.firstName = user.firstName;
                    searchResultModel.lastName = user.lastName;
                    }
            });

        });

        //map address data to search results 
        _.forEach(searchViewModel.controllingTaxAddresses, (address: Model.IAddress) => {

            _.forEach(searchResults, (searchResultModel: SearchResultModel) => {
                if (searchResultModel.controllingTaxAddressId === address.id) {
                    searchResultModel.controllingTaxAddress = address;
                }
            });

        });

        searchViewModel.searchResults = searchResults;

        return searchViewModel;

    }
  
}